// 權限解構
export function parseAuthJSON(data) {
    return {
        ...data,
        ...JSON.parse(data.auth)
    }
}
  